(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NeoReservationCore = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var PENDING_KEY = 'igulu_s1_neo_reservation_pending_signup';
  var CONFIRMED_KEY = 'igulu_s1_neo_reservation_confirmed_signup';
  var MAX_AGE_MS = 86400000;

  function validEmail(value) {
    return typeof value === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()) && value.length <= 254;
  }

  function pendingSignup(raw, confirmation, now) {
    if (confirmation !== 'confirmed') return null;
    var value;
    try { value = typeof raw === 'string' ? JSON.parse(raw) : raw; } catch (error) { return null; }
    if (!value || !validEmail(value.email) || !Number.isFinite(value.savedAt)) return null;
    var age = now - value.savedAt;
    if (age < 0 || age > MAX_AGE_MS) return null;
    return { email: value.email.trim(), formId: value.formId || 'NeoReservationSignup', savedAt: value.savedAt };
  }

  function subscriptionSucceeded(responseOk, payload) {
    return responseOk === true && !!payload && payload.success === true;
  }

  function subscriptionBody(email, listId) {
    if (!validEmail(email) || !/^[a-zA-Z0-9]+$/.test(listId || '')) throw new Error('Invalid signup data');
    var body = new URLSearchParams();
    body.set('g', listId);
    body.set('email', email.trim());
    body.set('$source', 'S1 Neo Reservation Signup');
    body.set('$consent', 'email');
    body.set('reservation_campaign', 's1-neo-launch');
    body.set('reservation_source_version', '2026-11-03');
    body.set('$fields', '$source,$consent,reservation_campaign,reservation_source_version');
    body.set('$list_fields', '$consent');
    return body.toString();
  }

  function checkoutURL(origin, cartPath, variantId, email) {
    var id = String(variantId || '');
    if (!/^\d+$/.test(id)) throw new Error('Reservation is unavailable');
    if (!/^\/(?:[^?#]+\/)?cart\/?$/.test(cartPath || '')) throw new Error('Invalid cart path');
    var path = cartPath.replace(/\/$/, '') + '/' + id + ':1';
    var url = new URL(path, origin);
    url.searchParams.set('attributes[reservation_campaign]', 's1-neo-launch');
    url.searchParams.set('ref', 's1-neo-reservation');
    if (email) {
      if (!validEmail(email)) throw new Error('Invalid checkout email');
      url.searchParams.set('checkout[email]', email.trim());
    }
    return url.toString();
  }

  return {
    PENDING_KEY: PENDING_KEY,
    CONFIRMED_KEY: CONFIRMED_KEY,
    MAX_AGE_MS: MAX_AGE_MS,
    validEmail: validEmail,
    pendingSignup: pendingSignup,
    subscriptionSucceeded: subscriptionSucceeded,
    subscriptionBody: subscriptionBody,
    checkoutURL: checkoutURL
  };
});
